import { render } from "./relese.vue?vue&type=template&id=e10124c2"
import script from "./relese.vue?vue&type=script&lang=js"
export * from "./relese.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\work\\project\\intelegent\\ips\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__